// lib
import { lazy } from "react";

// eslint-disable-next-line no-inline-comments
const App = lazy(() =>
  // eslint-disable-next-line no-inline-comments
  import("./AppContainer" /* webpackChunkName: "app-container" */)
);

export default App;
